export class ValueHelper {
	static getValueOrDefault(value: any, defaultValue: any): any {

		/*
		if (typeof param === 'string') {
			this.myvariable = <T><any>"";
		}
		else if (typeof param === 'number') {
			this.myvariable = <T><any>0;
		}
		*/
		return (value !== undefined ? value : defaultValue);
	}
}
